// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  getServiceRequestsStatus: { data: null },
  updateServiceStatus: { data: null },
  getServiceRequestsUsersStatus: { data: null },
  CreateQuickActionStatus: { data: null },
  getServiceRequestsByCompanyStatus: { data: null },
  createServicesRequestStatus: { data: null },
  serviceRequestsUsersStatus: { data: null },
  deleteServiceRequestStatus: { data: null },
};
